import { homeRouter } from '@/modules/web/modules/home/router/homeRouter'
import { experiencesRouter } from '@/modules/web/modules/experiences/router/experiencesRouter'
import { knowledgeRouter } from '@/modules/web/modules/knowledge/router/knowledgeRouter'
import { postsRouter } from '@/modules/web/modules/posts/router/postsRouter'
import { usesRouter } from '@/modules/web/modules/uses/router/usesRouter'
import { aboutRouter } from '@/modules/web/modules/about/router/aboutRouter'
import { pokemontcgRouter } from '@/modules/web/modules/pokemontcg/router/pokemontcgRouter'
import { projectDependenciesRouter } from '@/modules/web/modules/project-dependencies/router/projectDependenciesRouter'
import { notFoundRouter } from '@/modules/web/modules/404/router/404Router'

const webRouter = {
  path: '/',
  component: () => import('../views/Web.vue'),
  children: [
    homeRouter,
    experiencesRouter,
    knowledgeRouter,
    postsRouter,
    postsRouter,
    usesRouter,
    aboutRouter,
    projectDependenciesRouter,
    pokemontcgRouter,
    notFoundRouter
  ]
}

export { webRouter }
